import {PlannerFeature} from '../enums'

import {usePlantConfigQuery} from './api/dataScience/usePlantConfigQuery'

/**
 * @deprecated Remove after planner features are exported to config cat
 */
export const usePlannerFeature = (feature: PlannerFeature) => {
  const {data: plantConfig} = usePlantConfigQuery()
  const availableFeatures = plantConfig?.available_features || []

  return availableFeatures.includes(feature)
}
